// Module
var code = "<div><a href=# ng-click=\"$event.preventDefault();$ctrl.showHelpText = !$ctrl.showHelpText;\" class={{::$ctrl.s.help_text_title}} aria-expanded={{!!$ctrl.showHelpText}} aria-controls=orderNumberHelp>{{$ctrl.titleText}}</a><div ng-bind-html=$ctrl.helpText ng-show=$ctrl.showHelpText class={{::$ctrl.s.help_text_description}} id=orderNumberHelp></div></div>";
// Exports
var _module_exports =code;;
var path = '/r2/js/components/ReturnsHelpTooltip/returnsHelpTooltip.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;